import { FC, ReactNode } from 'react'
import { Container, Content } from 'rsuite'

import useRequireAuth from '../../services/useRequireAuth'
import BuyerSideNav from './BuyerSideNav'
import ProfileMobileLayout from './ProfileMobileLayout'
import { AccountNavigationRefs, BuyerProfileNavigationRefs, SavedProductsNavigationRefs } from '../../utils/types/buyerProfileTypes'

import styles from '../../styles/BuyerPortal/BuyerProfileLayout.module.less'

interface BuyerProfiletProps{
  accountNavigationRefs?: AccountNavigationRefs
  savedProductsNavigationRefs?: SavedProductsNavigationRefs
  showWelcome?: boolean
  mobileHeader?: ReactNode
  mobileBlocker?: boolean
  showProfileMobileLayout?: boolean
  children: ReactNode
}

const BuyerProfileLayout: FC<BuyerProfiletProps> = (props) => {
  const {
    accountNavigationRefs,
    savedProductsNavigationRefs,
    showWelcome,
    mobileBlocker,
    mobileHeader,
    children,
    showProfileMobileLayout = true,
  } = props

  const navigationRefs: BuyerProfileNavigationRefs = {
    ...accountNavigationRefs,
    ...savedProductsNavigationRefs,
  }

  useRequireAuth() // Redirect to login when token expires

  return (
    <div className={styles['buyer-profile-layout-wrapper']}>
      <div className={styles['mobile-layout-wrapper']}>
        {showProfileMobileLayout && (
        <div className="margin-left-spacer-double margin-right-spacer-double">
          <ProfileMobileLayout
            showWelcome={showWelcome}
            header={mobileHeader}
            mobileBlocker={mobileBlocker}
          />
        </div>
        )}
        {!mobileBlocker && children}
      </div>
      <Container className="max-width-lg">
        <div className={styles['layout-wrapper']}>
          <BuyerSideNav navigationRefs={navigationRefs} />
          <Content className={styles['content-container']}>
            {children}
          </Content>
        </div>
      </Container>
    </div>
  )
}

export default BuyerProfileLayout
